import prizeSelect from "./prizeSelect.container";

export default prizeSelect;
